import { PageLoadError } from 'design-system/src/components/PageLoadError/PageLoadError';

export function FormNotFound() {
  // TODO(WIT-4769) -- show a different message + button to request a new form to be sent
  return <PageLoadError />;
}
